<template>
  <div class="ViavenirLyceePatientReport pt-5"
       style="max-width: 1000px; margin: 0 auto">
    <Logo class="mb-10"
          style="margin:0 auto"></Logo>
    <div style="color: black">
      <div style="font-size: 28px">RAPPORT | <b>{{report.patient.first_name}} {{report.patient.last_name}}</b>
      </div>
      <hr class="mb-1">
      <div class="mb-10"
           style="display: flex; justify-content: space-between;">
        <span>Votre coach : {{report.patient.doctor.first_name}} {{report.patient.doctor.last_name}}</span>
        <span>© VIASANTÉ 2019</span>
      </div>
    </div>
    <div style="" class="py-5 PrintBtn">
      <div class="flex-grow-1"></div>
      <form>
        <v-btn type=button name=print value="Print" onClick="window.print()" class="primary">IMPRIMER</v-btn>
      </form>
    </div>
    <h2 class="section-title primary--text">Historique et attentes par rapport à l'intervention</h2>
    <hr>
    <h2 class="mb-3">Histoire scolaire et/ou professionnelle</h2>
    <div v-if="report.data['ViavenirQuestionnairePrealableForm']">
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['votre-histoire-scolaire-etou-professionnelle-depuis-la-rentree-de-septembre-2019'].annee_n.label}} : <b>{{report.data['ViavenirQuestionnairePrealableForm']['votre-histoire-scolaire-etou-professionnelle-depuis-la-rentree-de-septembre-2019'].annee_n.value}}</b></p>
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['votre-histoire-scolaire-etou-professionnelle-depuis-la-rentree-de-septembre-2019'].annee_n_1.label}} : <b>{{report.data['ViavenirQuestionnairePrealableForm']['votre-histoire-scolaire-etou-professionnelle-depuis-la-rentree-de-septembre-2019'].annee_n_1.value}}</b></p>
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['votre-histoire-scolaire-etou-professionnelle-depuis-la-rentree-de-septembre-2019'].annee_n_2.label}} : <b>{{report.data['ViavenirQuestionnairePrealableForm']['votre-histoire-scolaire-etou-professionnelle-depuis-la-rentree-de-septembre-2019'].annee_n_2.value}}</b></p>
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['votre-histoire-scolaire-etou-professionnelle-depuis-la-rentree-de-septembre-2019'].annee_n_3.label}} : <b>{{report.data['ViavenirQuestionnairePrealableForm']['votre-histoire-scolaire-etou-professionnelle-depuis-la-rentree-de-septembre-2019'].annee_n_3.value}}</b></p>

      <h2 class="mb-3">Disciplines générales</h2>
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['disciplines-generales']['preferences-points-forts'].label}} : <b>{{report.data['ViavenirQuestionnairePrealableForm']['disciplines-generales']['preferences-points-forts'].value}}</b></p>
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['disciplines-generales']['rejets-difficultes'].label}} : <b>{{report.data['ViavenirQuestionnairePrealableForm']['disciplines-generales']['rejets-difficultes'].value}}</b></p>

      <h2 class="mb-3">Disciplines optionnelles ou extra-scolaires</h2>
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['disciplines-optionnelles-ou-extra-scolaires']['latin-grec-musique-sport-loisirs'].value}}</p>

      <h2 class="mb-3">Travaux saisonniers effectués</h2>
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['travaux-saisonniers-effectues']['description'].value}}</p>

      <h2 class="mb-3">Avez-vous déjà réfléchi à la formation ou la profession que vous aimeriez choisir ?</h2>
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['avez-vous-deja-reflechi-a-la-formation-ou-la-profession-que-vous-aimeriez-choisir']['formation-ou-profession'].value ? 'Oui' : 'Non'}}</p>

      <h2 class="mb-3">Dans quelle mesure êtes-vous sûr(e) de votre choix ?</h2>
      <p>{{report.data['ViavenirQuestionnairePrealableForm']['dans-quelle-mesure-etes-vous-sure-de-votre-choix']['1-pas-sure-du-tout-10-tres-sure']['value']}} / 10</p>

      <h2 class="mb-3">Quelles démarches avez-vous entreprises jusqu'alors en matière d'orientation ?</h2>
      <ul class="mb-3">
        <li v-if="report.data['ViavenirQuestionnairePrealableForm']['quelles-demarches-avez-vous-entreprises-jusqualors-en-matiere-dorientation'][key].value.checked"
            :key="key"
            v-for="key in Object.keys(report.data['ViavenirQuestionnairePrealableForm']['quelles-demarches-avez-vous-entreprises-jusqualors-en-matiere-dorientation'])">
          {{report.data['ViavenirQuestionnairePrealableForm']['quelles-demarches-avez-vous-entreprises-jusqualors-en-matiere-dorientation'][key].label}}
          <br> {{report.data['ViavenirQuestionnairePrealableForm']['quelles-demarches-avez-vous-entreprises-jusqualors-en-matiere-dorientation'][key].value.description}}
        </li>
      </ul>

      <h2 class="mb-3">Quelles sont vos attentes par rapport à notre intervention ?</h2>
      <p class="primary--text fw500">{{report.data['ViavenirQuestionnairePrealableForm']['quelles-sont-vos-attentes-par-rapport-a-notre-intervention']['liste-par-ordre-dimporte-decroissante'].value}}</p>
    </div>
    <div v-else>Mission non remplie.</div>

    <h2 class="mt-10 section-title primary--text">Vos besoins</h2>
    <hr>

    <div class="mt-5 ApexChart"
         style="display: flex; justify-content: center">
      <apexchart width="600"
                 type="pie"
                 v-if="typeInterventionChart"
                 :series="typeInterventionChart.series"
                 :options="typeInterventionChart.options"></apexchart>
    </div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"
                style="width: 80%">Type d'intervention
            </th>
            <th class="text-left">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Connaissance de soi</td>
            <td>{{report.data['vos-besoins-chart']['type_intervention']['Connaissance Soi']}}</td>
          </tr>
          <tr>
            <td>Connaissance de l'environnement</td>
            <td>{{report.data['vos-besoins-chart']['type_intervention']['Connaissance Environnement']}}</td>
          </tr>
          <tr>
            <td>Accompagnement</td>
            <td>{{report.data['vos-besoins-chart']['type_intervention']['Accompagnement']}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="mt-5 ApexChart"
         style="display: flex; justify-content: center">
      <apexchart width="600"
                 type="pie"
                 v-if="domaineDifficulteChart"
                 :series="domaineDifficulteChart.series"
                 :options="domaineDifficulteChart.options"></apexchart>
    </div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"
                style="width: 80%">Domaine de difficulté
            </th>
            <th class="text-left">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Maturité du projet</td>
            <td>{{report.data['vos-besoins-chart']['domaine_difficulte']['MATURITE DU PROJET']}}</td>
          </tr>
          <tr>
            <td>Manque d'informations</td>
            <td>{{report.data['vos-besoins-chart']['domaine_difficulte']["MANQUE d'INFORMATIONS"]}}</td>
          </tr>
          <tr>
            <td>Informations contradictoires</td>
            <td>{{report.data['vos-besoins-chart']['domaine_difficulte']['INFORMATIONS CONTRADICTOIRES']}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="mt-5 ApexChart"
         style="display: flex; justify-content: center">
      <apexchart width="800"
                 type="bar"
                 v-if="natureChart"
                 :series="natureChart.series"
                 :options="natureChart.options"></apexchart>
    </div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"
                style="width: 80%">Nature
            </th>
            <th class="text-left">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="n in Object.keys(report.data['vos-besoins-chart']['nature'])">
            <td>{{n | ucfirst}}</td>
            <td>{{report.data['vos-besoins-chart']['nature'][n]}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <h2 class="mb-3 mt-5 py-10">Liste complète des réponses</h2>
    <v-simple-table v-if="report.data['ViavenirQuestionnairePersonnaliteForm']">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"
                style="width: 80%">Question
            </th>
            <th class="text-left">Note</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="n in Object.keys(report.data['ViavenirQuestionnairePersonnaliteForm']['questionnaire-de-personnalite'])"
              :class="report.data['ViavenirQuestionnairePersonnaliteForm']['questionnaire-de-personnalite'][n].value >= 7 ? 'primary--text fw500' : ''">
            <td>{{report.data['ViavenirQuestionnairePersonnaliteForm']['questionnaire-de-personnalite'][n].label}}</td>
            <td>{{report.data['ViavenirQuestionnairePersonnaliteForm']['questionnaire-de-personnalite'][n].value}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-else>Mission non remplie</div>

    <h2 class="section-title primary--text mt-10">Questionnaire des centres d'intérêt</h2>
    <hr>

    <div class="mt-5 ApexChart"
         style="display: flex; justify-content: center">
      <apexchart
                 class="flex-grow-1 too-large-to-print"
                 type="bar"
                 v-if="iaipCategoriesChart"
                 :series="iaipCategoriesChart.series"
                 :options="iaipCategoriesChart.options"></apexchart>
    </div>

    <div v-for="(subcategories, category) in this.report.data['iaip-subcategories']">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left"
                  style="width: 80%">{{category}}
              </th>
              <th class="text-left">Notes</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(n,v) in subcategories">
              <td>{{v}}</td>
              <td>{{n.total}}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div class="mt-5 ApexChart"
           style="display: flex; justify-content: center">
        <apexchart width="500"
                   type="bar"
                   :series="[{data: Object.values(subcategories).map(v => v.round)}]"
                   :options="{xaxis: {categories: Object.keys(subcategories)}, yaxis: {min: 0, max: 5}}"></apexchart>
      </div>
    </div>

    <h2 class="mb-3 py-10">Liste complète des réponses (> 3)</h2>
    <v-simple-table v-if="report.data['iaip-chart']">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"
                style="width: 80%">Question
            </th>
            <th class="text-left">Note</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="n in Object.keys(report.data['iaip-chart']).filter(k => report.data['iaip-chart'][k].value > 3).map(k => report.data['iaip-chart'][k])">
            <td>{{n.label}}</td>
            <td>{{n.value}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <h2 class="mt-10 section-title primary--text">Typologie des qualités</h2>
    <hr>
    <div v-if="report.data['ViavenirTypologieQualitesForm']">
      <p>Qualités principales :</p>
      <ul>
        <li v-for="n in Object.keys(report.data['ViavenirTypologieQualitesForm']['questionnaire']).filter(k => report.data['ViavenirTypologieQualitesForm']['questionnaire'][k].value === '+').map(k => report.data['ViavenirTypologieQualitesForm']['questionnaire'][k].label)">{{n}}</li>
      </ul>

      <p class="mt-5">Tri des qualités principales :</p>
      <ul>
        <li style="list-style-type: none">1er choix : {{report.data['ViavenirTypologieQualitesForm']['maintenant-classez-les-adjectifs-que-vous-avez-notes-par-ordre-dimportance-decroissant']['1er-choix']['value']}}</li>
        <li style="list-style-type: none">2ème choix : {{report.data['ViavenirTypologieQualitesForm']['maintenant-classez-les-adjectifs-que-vous-avez-notes-par-ordre-dimportance-decroissant']['2eme-choix']['value']}}</li>
        <li style="list-style-type: none">3ème choix : {{report.data['ViavenirTypologieQualitesForm']['maintenant-classez-les-adjectifs-que-vous-avez-notes-par-ordre-dimportance-decroissant']['3eme-choix']['value']}}</li>
        <li style="list-style-type: none">4ème choix : {{report.data['ViavenirTypologieQualitesForm']['maintenant-classez-les-adjectifs-que-vous-avez-notes-par-ordre-dimportance-decroissant']['4eme-choix']['value']}}</li>
        <li style="list-style-type: none">5ème choix : {{report.data['ViavenirTypologieQualitesForm']['maintenant-classez-les-adjectifs-que-vous-avez-notes-par-ordre-dimportance-decroissant']['5eme-choix']['value']}}</li>
        <li style="list-style-type: none">6ème choix : {{report.data['ViavenirTypologieQualitesForm']['maintenant-classez-les-adjectifs-que-vous-avez-notes-par-ordre-dimportance-decroissant']['6eme-choix']['value']}}</li>
      </ul>
    </div>
    <div v-else>Mission non remplie.</div>

    <h2 class="mt-10 section-title primary--text">Typologie des activités</h2>
    <hr>
    <div v-if="report.data['ViavenirTypologieActivitesForm']">
      <p>Activités préférées :</p>
      <ul>
        <li v-for="n in Object.keys(report.data['ViavenirTypologieActivitesForm']['questionnaire']).filter(k => report.data['ViavenirTypologieActivitesForm']['questionnaire'][k].value === '+').map(k => report.data['ViavenirTypologieActivitesForm']['questionnaire'][k].label)">{{n}}</li>
      </ul>

      <p class="mt-5">Tri des activités principales :</p>
      <ul>
        <li style="list-style-type: none">1er choix : {{report.data['ViavenirTypologieActivitesForm']['maintenant-classez-les-verbes-que-vous-avez-notes-par-ordre-dimportance-decroissant']['1er-choix']['value']}}</li>
        <li style="list-style-type: none">2ème choix : {{report.data['ViavenirTypologieActivitesForm']['maintenant-classez-les-verbes-que-vous-avez-notes-par-ordre-dimportance-decroissant']['2eme-choix']['value']}}</li>
        <li style="list-style-type: none">3ème choix : {{report.data['ViavenirTypologieActivitesForm']['maintenant-classez-les-verbes-que-vous-avez-notes-par-ordre-dimportance-decroissant']['3eme-choix']['value']}}</li>
        <li style="list-style-type: none">4ème choix : {{report.data['ViavenirTypologieActivitesForm']['maintenant-classez-les-verbes-que-vous-avez-notes-par-ordre-dimportance-decroissant']['4eme-choix']['value']}}</li>
        <li style="list-style-type: none">5ème choix : {{report.data['ViavenirTypologieActivitesForm']['maintenant-classez-les-verbes-que-vous-avez-notes-par-ordre-dimportance-decroissant']['5eme-choix']['value']}}</li>
        <li style="list-style-type: none">6ème choix : {{report.data['ViavenirTypologieActivitesForm']['maintenant-classez-les-verbes-que-vous-avez-notes-par-ordre-dimportance-decroissant']['6eme-choix']['value']}}</li>
      </ul>
    </div>
    <div v-else>Mission non remplie</div>

    <h2 class="mt-10 section-title primary--text">Type de personnalité professionnelle</h2>
    <hr>
    <div v-if="report.data['ViavenirProfilProfessionnelForm']">
      <p><b>1.</b> : {{profilProfessionnelMap[report.data['ViavenirProfilProfessionnelForm']['votre-selection']['1er-choix'].value]}}</p>
      <p><b>2.</b> : {{profilProfessionnelMap[report.data['ViavenirProfilProfessionnelForm']['votre-selection']['2eme-choix'].value]}}</p>
      <p><b>3.</b> : {{profilProfessionnelMap[report.data['ViavenirProfilProfessionnelForm']['votre-selection']['3eme-choix'].value]}}</p>
    </div>
    <div v-else>Mission non remplie</div>
    <h2 class="mt-10 section-title primary--text">Tempéraments</h2>
    <hr>
    <div v-if="report.data['ViavenirTemperamentsFormBlock']">
      <p><b>1.</b>: {{temperamentsMap[report.data['ViavenirTemperamentsFormBlock']['maintenant-notez-les-3-temperaments-retenus-par-ordre-dimportance-decroissant']['1er-choix'].value]}}</p>
      <p><b>2.</b>: {{temperamentsMap[report.data['ViavenirTemperamentsFormBlock']['maintenant-notez-les-3-temperaments-retenus-par-ordre-dimportance-decroissant']['2eme-choix'].value]}}</p>
      <p><b>3.</b>: {{temperamentsMap[report.data['ViavenirTemperamentsFormBlock']['maintenant-notez-les-3-temperaments-retenus-par-ordre-dimportance-decroissant']['3eme-choix'].value]}}</p>
    </div>
    <div v-else>Mission non remplie</div>

    <div v-if="report.data['ViavenirEnvironnementForm']">
      <h2 class="mt-10 section-title primary--text">Environnement et conditions de travail</h2>
      <hr>
      <div v-if="report.data['ViavenirEnvironnementForm']">
        <h2 class="mb-3">Niveau de formation souhaité</h2>
        <p>{{bacLvlMap[report.data['ViavenirEnvironnementForm']['niveau-de-formation-souhaite']['apres-le-bac'].value]}}</p>
        <p>{{report.data['ViavenirEnvironnementForm']['niveau-de-formation-souhaite'].pourquoi.value}}</p>

        <h2 class="mb-3">Intérieur / Plein air</h2>
        <p>{{environnementMap[report.data['ViavenirEnvironnementForm']['interieur-plein-air']['environnement-de-travail'].value]}}</p>
        <p>{{environnementMap[report.data['ViavenirEnvironnementForm']['interieur-plein-air']['commentaires'].value]}}</p>

        <h2 class="mb-3">Rémunération</h2>
        <p>{{report.data['ViavenirEnvironnementForm']['remuneration']['quel-est-le-salaire-mensuel-net-souhaite-en-debut-de-carriere'].value}}€</p>
        <p>{{report.data['ViavenirEnvironnementForm']['remuneration']['pourquoi'].value}}</p>

        <h2 class="mb-3">Force et endurance physique</h2>
        <p>{{niveauEffortMap[report.data['ViavenirEnvironnementForm']['force-et-endurance-physique']['quel-est-le-niveau-maximal-deffort-physique-acceptable-dans-mon-travail'].value]}}</p>

        <h2 class="mb-3">Milieu de travail</h2>
        <p class="primary--text fw500">{{report.data['ViavenirEnvironnementForm']['milieu-de-travail']['decrire-en-2-lignes-son-environnement-de-travail-ideal-humain-et-materiel']['value']}}</p>
        <p v-for="key in Object.keys(report.data['ViavenirEnvironnementForm']['cocher-laes-phrases-correspondant-a-ce-que-vous-voulez-eviter-de-faire']).filter(k => report.data['ViavenirEnvironnementForm']['cocher-laes-phrases-correspondant-a-ce-que-vous-voulez-eviter-de-faire'][k].value.checked)">{{milieuTravailMap[key]}}</p>
      </div>
      <div v-else>Mission non remplie</div>
    </div>

    <div v-if="report.data['student-comments']">
      <h2>Commentaires de l'élève</h2>
      <h3>Verbes</h3>
      <ParagraphBlock>{{report.data['student-comments'].verbe_1}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].verbe_2}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].verbe_3}}</ParagraphBlock>

      <h3>Qualités</h3>
      <ParagraphBlock>{{report.data['student-comments'].qualite_1}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].qualite_2}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].qualite_3}}</ParagraphBlock>

      <h3>Codes de Holland</h3>
      <ParagraphBlock>{{report.data['student-comments'].code_holland_1}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].code_holland_2}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].code_holland_3}}</ParagraphBlock>

      <h3>Tempéraments</h3>
      <ParagraphBlock>{{report.data['student-comments'].temperament_1}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].temperament_2}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].temperament_3}}</ParagraphBlock>

      <h3>Inventaire Approfondi des Intérêts Professionnels</h3>
      <ParagraphBlock>{{report.data['student-comments'].iaip_domaine_1}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].iaip_domaine_2}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].iaip_domaine_3}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].iaip_activite_1}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].iaip_activite_2}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].iaip_activite_3}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].analyse_approfondie}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].quels_commentaires}}</ParagraphBlock>

      <h3>Mes compétences spécifiques</h3>
      <ParagraphBlock>{{report.data['student-comments'].mes_connaissances}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].mes_experiences}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].mes_pistes_orientation}}</ParagraphBlock>

      <h3>Besoins et attentes</h3>
      <ParagraphBlock>{{report.data['student-comments'].mes_etudes}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].ma_formation}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].mobilite}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].environnement_de_travail}}</ParagraphBlock>

      <h3>Rechercher, organiser et suivre l'information</h3>
      <ParagraphBlock>{{report.data['student-comments'].pistes_possibles}}</ParagraphBlock>

      <h3>Quelles sont les pistes d'orientation...</h3>
      <ParagraphBlock>{{report.data['student-comments'].elimine_pourquoi}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].conserve_pourquoi}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].elargis_pourquoi}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].position_famille}}</ParagraphBlock>
      <ParagraphBlock>{{report.data['student-comments'].obstacles_realisation}}</ParagraphBlock>

      <h3>Plan d'action</h3>
      <ParagraphBlock>{{report.data['student-comments'].plan_action}}</ParagraphBlock>
    </div>

    <div class="text-center">© VIASANTÉ 2019</div>
  </div>
</template>

<script>

  import ParagraphBlock from '../../blocks/ParagraphBlock'
  import Logo from '../../common/Logo'

  export default {
    components: {
      ParagraphBlock,
      Logo
    },

    computed: {
      iaipCategoriesChart () {
        if (!this.report.data['iaip-categories']) {
          return false
        }

        return {
          chart: {
            width: this.printing ? "75%" : "100%",
            height: "500px",
          },
          series: [{
            data: Object.keys(this.report.data['iaip-categories']).map(k => this.report.data['iaip-categories'][k])
          }],
          options: {
            plotOptions: {
              bar: {
                horizontal: true,
              }
            },
            dataLabels: {
              enabled: true
            },
            xaxis: {
              categories: Object.keys(this.report.data['iaip-categories']),
            },
            yaxis: {
              labels: {
                maxWidth: 300
              }
            }
          }
        }
      },

      typeInterventionChart () {
        if (!this.report.data['vos-besoins-chart']) {
          return false
        }

        return {
          series: [
            this.report.data['vos-besoins-chart']['type_intervention']['Connaissance Soi'],
            this.report.data['vos-besoins-chart']['type_intervention']['Connaissance Environnement'],
            this.report.data['vos-besoins-chart']['type_intervention']['Accompagnement'],
          ],
          options: {
            theme: {
              palette: 'palette6'
            },
            labels: [
              'Connaissance de soi', "Connaissance de l'environnement", 'Accompagnement'
            ]
          }
        }
      },

      domaineDifficulteChart () {
        if(!this.report.data['vos-besoins-chart']['domaine_difficulte'].length) {
          return false
        }

        return {
          series: [
            this.report.data['vos-besoins-chart']['domaine_difficulte']['MATURITE DU PROJET'],
            this.report.data['vos-besoins-chart']['domaine_difficulte']['MANQUE d\'INFORMATIONS'],
            this.report.data['vos-besoins-chart']['domaine_difficulte']['INFORMATIONS CONTRADICTOIRES'],
          ],
          options: {
            labels: [
              'Maturité du projet', "Manque d'informations", 'Informations contradictoires'
            ]
          }
        }
      },

      natureChart () {
        if (!this.report.data['vos-besoins-chart']['nature'].length) {
          return false
        }

        return {
          series: [{
            data: Object.keys(this.report.data['vos-besoins-chart']['nature']).map(n => this.report.data['vos-besoins-chart']['nature'][n])
          }],
          options: {
            colors: ['#008FFB', '#008FFB', '#008FFB', '#008FFB', '#00E396', '#00E396', '#00E396', '#FEB019', '#FEB019', '#FEB019'],
            plotOptions: {
              bar: {
                distributed: true,
                horizontal: true,
              }
            },
            dataLabels: {
              enabled: true
            },
            xaxis: {
              categories: Object.keys(this.report.data['vos-besoins-chart']['nature']),
            },
            yaxis: {
              labels: {
                maxWidth: 300
              }
            }
          }
        }
      },

      profilProfessionnelMap () {
        return {
          "social-vous-aimez-comprendre-et-aider-les-autres": "Social : Vous aimez comprendre et aider les autres",
          "artistique-vous-aimez-creer-imaginer": "Artistique : Vous aimez créer, imaginer",
          "entreprenant-vous-aimez-agir-et-diriger": "Entreprenant : Vous aimez agir et diriger",
          "investigateur-vous-aimez-comprendre-connaitre-et-inventer": "Investigateur : Vous aimez comprendre, connaître et inventer",
          "realiste-vous-aimez-faire-des-choses-concretes": "Réaliste : Vous aimez faire des choses concrètes",
          "conventionnel-vous-aimez-suivre-des-regles-precises-et-que-tout-soit-en-ordre": "Conventionnel : Vous aimez suivre des règles précises et que tout soit en ordre",
        }
      },

      temperamentsMap () {
        return {
          'faire-un-travail-varie': 'Faire un travail varié',
          'faire-un-travail-uniforme': 'Faire un travail uniforme',
          'collaborer-avec-les-autres': 'Collaborer avec les autres',
          'exercer-une-influence': 'Exercer une influence',
          'faire-un-travail-stressant': 'Faire un travail stressant',
          'utiliser-son-propre-jugement': 'Utiliser son propre jugement',
          'faire-un-travail-meticuleux': 'Faire un travail méticuleux',
          'juger-sur-faits-concrets': 'Juger sur faits concrets',
          'exprimer-sa-personnalite': 'Exprimer sa personnalité',
          'prendre-des-responsabilites': 'Prendre des responsabilités'
        }
      },

      bacLvlMap () {
        return {
          "bac-a-bac-2": "Bac à bac +2",
          "bac-3-a-bac-4": "Bac +3 à bac +4",
          "bac-5-ou-plus": "Bac +5 ou plus"
        }
      },

      environnementMap () {
        return {
          "je-veux-travailler-a-linterieur-cest-a-dire-la-plupart-du-temps-dans-un-bureau-ou-un-batiment-a-labri-du-soleil-du-vent-de-la-pluie": "Je veux travailler à l'intérieur, c'est à dire la plupart du temps dans un bureau ou un bâtiment à l'abri du soleil, du vent, de la pluie...",
          "je-veux-travailler-en-plein-air-cest-a-dire-la-plus-grande-partie-du-temps-dehors-expose-au-vent-a-la-pluie-a-la-neige": "Je veux travailler en plein air, c'est à dire la plus grande partie du temps dehors, exposé au vent, à la pluie, à la neige...",
          "je-veux-travailler-autant-a-linterieur-quen-plein-air": "Je veux travailler autant à l'intérieur qu'en plein air."
        }
      },

      niveauEffortMap () {
        return {
          "travail-ne-necessitant-aucune-force-physique": "Travail ne nécessitant aucune force physique",
          "travail-leger": "Travail léger",
          "travail-assez-lourd": "Travail assez lourd",
          "travail-lourd": "Travail lourd"
        }
      },

      milieuTravailMap () {
        return {
          "je-ne-veux-pas-travailler-au-froid": "Je ne veux pas travailler au froid",
          "je-ne-veux-pas-travailler-a-la-chaleur": "Je ne veux pas travailler à la chaleur",
          "je-ne-veux-pas-travailler-dans-lhumidite-ou-au-contact-de-leau": "Je ne veux pas travailler dans l’humidité ou au contact de l’eau",
          "je-ne-veux-pas-travailler-dans-le-bruit-ou-les-vibrations": "Je ne veux pas travailler dans le bruit ou les vibrations",
          "je-ne-veux-pas-travailler-dans-un-milieu-a-risques-daccidents": "Je ne veux pas travailler dans un milieu à risques d’accidents",
          "je-ne-veux-pas-travailler-dans-la-poussiere-les-odeurs-desagreables": "Je ne veux pas travailler dans la poussière, les odeurs désagréables",
          "je-ne-veux-pas-travailler-avec-des-contraintes-horaires-ou-des-deplacements": "Je ne veux pas travailler avec des contraintes horaires ou des déplacements",
        }
      }
    },

    data () {
      return {
        printing: false,
      }
    },

    props: {
      report: {
        required: true
      }
    },

    methods: {
      beforePrint () {
        console.log('before');
        this.printing = true;
      },

      afterPrint () {
        console.log('after');
        this.printing = false;
      },

      listener (mql) {
        if (mql.matches) {
          this.beforePrint();
        } else {
          this.afterPrint();
        }
      },
    },

    mounted () {
      if (window.matchMedia) {
        let mediaQueryList = window.matchMedia('print');
        mediaQueryList.addListener(this.listener);
      }

      window.onbeforeprint = this.beforePrint;
      window.onafterprint = this.afterPrint;
    },
  }
</script>

<style lang="scss"
       type="text/scss">
  .ViavenirLyceePatientReport {
    .section-title + hr {
      border: 1px solid #EA5B0C;
    }
    .PrintBtn {
      position: sticky;
      top: 0;
      display: flex;
      flex-direction: row;
    }

  }

  @media print {
    .DevToolsFloatingButton {
      display: none;
    }

    .DoctorNavbar {
      display: none;
    }

    .PrintBtn {
      display: none!important;
    }

    .ApexChart {
      break-inside: avoid;
      page-break-inside: avoid;
      max-width: 100%;
    }

    .too-large-to-print {
      width: 65%;
    }

    .v-simple-table {
      break-inside: avoid;
      page-break-inside: avoid;
    }
  }
</style>
